

import React from "react";
import RuleTableBody from "../../component/DataMonitor/RuleTableBody";
import RuleTableHead from "../../component/DataMonitor/RuleTableHead";
import RuleTableHeader from "../../component/DataMonitor/RuleTableHeader";


const Tables = ({
  tableData = [],
  loading = false,
  ruleCount = 0,
  error = null,
  pagination = { page: 1, pageSize: 10, totalPages: 0, totalCount: 0 },
  onPageChange = () => { },
  onSearchSubmit = () => {},  
  onReset = () => {}, 
  onColumnSearchChange = () => { },
  columnSearch = {},
  onSortChange = () => { },


}) => {
  const items = [
    { color: "#FB0301", label: "< 90%" },
    { color: "#FFC100", label: "90% – 95%" },
    { color: "#009F52", label: "≥ 95%" },
  ];
  const tableContainerRef = React.useRef(null);
  const [sortColumn, setSortColumn] = React.useState(null);
  const [sortOrder, setSortOrder] = React.useState("asc");

  const handleSort = (column) => {
    let newOrder = "asc";
    if (sortColumn === column && sortOrder === "asc") {
      newOrder = "desc";
    }
    setSortColumn(column);
    setSortOrder(newOrder);

    if (typeof onSortChange === "function") {
      onSortChange(column, newOrder);
    }
  };
  const handleResetInputs = () => {
    if (typeof onColumnSearchChange === "function") {
      Object.keys(columnSearch).forEach((col) => onColumnSearchChange(col, ""));
    }
      onReset(); 
  };
  const renderHighlightedText = (text, searchTerm) => {
    if (!searchTerm || !text) return text;

    const parts = text.split(new RegExp(`(${searchTerm})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span key={i} style={{ backgroundColor: "orange", fontWeight: "500" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const truncateText = (text, maxLength = 30) =>
    text && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text || "NA";
  const truncateTexts = (text, maxLength = 15) =>
    text && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text || "NA";

  if (error) {
    return <div className="p-4 text-red-600">Error: {error}</div>;
  }

  const totalRecords = pagination.totalCount || 0;
  const pageSize = pagination.pageSize || 10;
  const currentPage = pagination.page || 1;
  const totalPages =
    pagination.totalPages && pagination.totalPages > 0
      ? pagination.totalPages
      : Math.max(1, Math.ceil(totalRecords / pageSize));

  const gotoPage = (p) => {
    const target = Math.max(1, Math.min(totalPages, p));
    if (target !== currentPage) onPageChange(target);
  };

  return (
    <div className="poppins-regular">
      <RuleTableHeader
        items={items}
        totalRecords={totalRecords}
        currentPage={currentPage}
        totalPages={totalPages}
        gotoPage={gotoPage}
        handleResetInputs={handleResetInputs}
        tableContainerRef={tableContainerRef}
        ruleCount={ruleCount}
      />
      <div
        ref={tableContainerRef}
        style={{ overflowX: "auto", scrollBehavior: "smooth" }}
      >          <table className="min-w-full border-collapse border border-gray-200 text-sm">

          <RuleTableHead
            sortColumn={sortColumn}
            sortOrder={sortOrder}
              onSearchSubmit={onSearchSubmit} 
            handleSort={handleSort}
            columnSearch={columnSearch}
            onColumnSearchChange={onColumnSearchChange}
          />
          <RuleTableBody
            tableData={tableData}
            loading={loading}
            columnSearch={columnSearch}
            renderHighlightedText={renderHighlightedText}
            truncateText={truncateText}
            truncateTexts={truncateTexts}
          />

        </table>
      </div>
    </div>
  );
};

export default Tables;
